// extracted by mini-css-extract-plugin
export default {"option":"MobileMenuOption_option__xCyhQ","active":"MobileMenuOption_active__lLFPG"};